import React from 'react';
import { Search as SearchIcon, SlidersHorizontal, X } from 'lucide-react';
import { FormatoHomeStrip } from '@/components/obra/FormatoHomeStrip';
import { Input } from '@/components/ui/Input';

interface SearchFilterBarProps {
    searchInput: string;
    onSearchInputChange: (val: string) => void;
    onSearchSubmit: () => void;
    onClearSearch: () => void;
    selectedFormato: number;
    onFormatoChange: (formato: number) => void;
    onOpenFilters: () => void;
    activeFiltersCount: number;
}

export const SearchFilterBar: React.FC<SearchFilterBarProps> = ({
    searchInput,
    onSearchInputChange,
    onSearchSubmit,
    onClearSearch,
    selectedFormato,
    onFormatoChange,
    onOpenFilters,
    activeFiltersCount,
}) => {
    return (
        <div className="space-y-5">
            <div className="flex gap-2">
                <div className="group relative flex-1">
                    <div className="pointer-events-none absolute inset-y-0 left-0 z-10 flex items-center pl-4 text-white/35 transition-colors group-focus-within:text-orange-500/90">
                        <SearchIcon size={20} strokeWidth={2.2} />
                    </div>
                    <Input
                        type="text"
                        placeholder="Buscar por título ou títulos alternativos…"
                        className="rounded-xl bg-white/[0.03] py-3.5 pl-12 pr-12 transition-all focus:bg-white/[0.05]"
                        value={searchInput}
                        onChange={(e) => onSearchInputChange(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && onSearchSubmit()}
                    />
                    {searchInput ? (
                        <button
                            type="button"
                            onClick={onClearSearch}
                            className="absolute inset-y-0 right-0 z-10 flex items-center pr-4 text-white/35 transition-colors hover:text-white"
                            aria-label="Limpar busca"
                        >
                            <X size={18} />
                        </button>
                    ) : null}
                </div>

                <button
                    type="button"
                    onClick={onOpenFilters}
                    aria-label="Abrir filtros"
                    className="relative flex shrink-0 items-center gap-2 rounded-xl border border-white/10 bg-white/[0.03] px-4 py-3.5 text-sm font-semibold text-white/60 transition-all hover:border-orange-500/40 hover:bg-white/[0.06] hover:text-white"
                >
                    <SlidersHorizontal size={18} strokeWidth={2.2} />
                    <span className="hidden sm:inline">Filtros</span>
                    {activeFiltersCount > 0 && (
                        <span className="absolute -right-1.5 -top-1.5 flex h-4 w-4 items-center justify-center rounded-full bg-orange-500 text-[10px] font-black text-white">
                            {activeFiltersCount}
                        </span>
                    )}
                </button>
            </div>

            <FormatoHomeStrip selectedFormato={selectedFormato} onSelect={onFormatoChange} showTodos />
        </div>
    );
};
